import ExportFile from './ExportFile'
import ExportField from './ExportField'
export class FileField {
    ID: number;
    FileID?: number;
    ExportFile: ExportFile;
    FieldID?: number;
    ExportField: ExportField;
    Sequence: number;
    Inactive: boolean;

}

export default FileField;